(function () {

  'use strict';

  function pxDiscoverPrinters(SnmpConfigurationService, WorkstationListPaging, NetworkListService, toastr, $filter, $http) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/discoverPrinters/discoverPrinters.template.html',
      link: function (scope, element) {

        scope.selectedWorkstation = null;
        scope.wsPaginationObject = null;
        scope.snmpConfigurationSelectorIsOpen = false;
        scope.networkId = scope.context ? scope.context._links.self.href.slice(-36) : null;
        scope.network = null;

        (function () {
          getNetwork(scope.networkId);
          getDefaultSnmpConfiguration();
        })();

        function getDefaultSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.selectedSnmpConfig = defaultSnmpConfiguration;
          }).catch(function(error){});
        }

        function getNetwork(networkId) {
          NetworkListService.getNetworkById(networkId).then(function (network) {
            scope.network = network;
          }).catch(function(error){});
        }

        scope.showSnmpList = function () {
          scope.snmpConfigurationSelectorIsOpen = true;
        };

        scope.getWorkstations = function () {
          const wsPaginationObject = new WorkstationListPaging();
          wsPaginationObject.pagingCriteria.networks = scope.context._links.self.href;
          wsPaginationObject.pagingCriteria.active = true;
          scope.wsPaginationObject = wsPaginationObject;
        };

        scope.selectSnmpConfig = function (snmpConfig) {
          scope.snmpConfigurationSelectorIsOpen = false;
          if (snmpConfig) {
            scope.selectedSnmpConfig = snmpConfig;
          }
        };

        scope.selectWorkstation = function (workstation) {
          scope.wsPaginationObject = null;
          scope.selectedWorkstation = workstation;
        };

        scope.createSnmpConfiguration = function (event) {
          scope.snmpConfigurationSelectorIsOpen = false;

          const snmpConfiguration = {
            info: {
              version: 'V1',
              networkIds: scope.network ? [scope.network.customProperties.id] : []
            }
          };

          scope.snmpFormData = {
            snmpConfiguration: angular.copy(snmpConfiguration),
            snmpConfigurationOriginal: snmpConfiguration,
            selectedNetworks: scope.network ? [{ id: scope.network.customProperties.id, name: scope.network.info.name }] : [],
            availableNetworks: scope.network ? [scope.network] : []
          };

          scope.addSnmpConfigurationPopupObject = {
            dimensions: { width: 600 },
            offset: { top: 50, left: 50 },
            pointerPosition: 'up',
            relativePosition: 'right',
            absoluteX: 0, // event.clientX,
            absoluteY: 0, // event.clientY,
            type: 'SNMP_FORMS',
            title: 'AddSnmpConfiguration',
            confirmText: 'Save',
            cancelText: 'Cancel',
            clickOutsideToClose: false
          };
        };

        scope.createSnmpConfiguration2 = function (snmpConfiguration) {
          const newSnmpConfiguration = {
            version: snmpConfiguration.info.version,
            name: snmpConfiguration.info.name,
            networkIds: snmpConfiguration.info.networkIds
          };

          if (newSnmpConfiguration.version === 'V1') {
            newSnmpConfiguration.communityName = snmpConfiguration.info.communityName;
            newSnmpConfiguration.communityNameSet = snmpConfiguration.info.communityNameSet;
          } else if (newSnmpConfiguration.version === 'V3') {
            newSnmpConfiguration.user = snmpConfiguration.info.user;
            newSnmpConfiguration.authenticationLevel = snmpConfiguration.info.authenticationLevel;
            newSnmpConfiguration.contextName = snmpConfiguration.info.contextName;

            if (newSnmpConfiguration.authenticationLevel === 'AUTHPRIV') {
              newSnmpConfiguration.authentication = snmpConfiguration.info.authentication;
              newSnmpConfiguration.authPhrase = snmpConfiguration.info.authPhrase;
              newSnmpConfiguration.privacy = snmpConfiguration.info.privacy;
              newSnmpConfiguration.privacyPhrase = snmpConfiguration.info.privacyPhrase;
            } else if (newSnmpConfiguration.authenticationLevel === 'AUTHNOPRIV') {
              newSnmpConfiguration.authentication = snmpConfiguration.info.authentication;
              newSnmpConfiguration.authPhrase = snmpConfiguration.info.authPhrase;
            }
          } else {
            throw String('Wrong SNMP version!');
          }

          scope.creatingSnmpConfiguration = true;
          SnmpConfigurationService.createSnmpConfiguration(newSnmpConfiguration).then(function (response) {
            scope.selectedSnmpConfig = { info: response.data };
            scope.creatingSnmpConfiguration = false;
            toastr.success($filter('stringular')($filter('translate')('SnmpConfigurationCreated'), response.data.name));
          }).catch(function(error){
            scope.creatingSnmpConfiguration = false;
            toastr.error($filter('translate')('SnmpConfigurationNotCreated'));
          });
        };

        scope.clearPopups = function () {
          scope.snmpFormData = null;
          scope.addSnmpConfigurationPopupObject = null;
        };

        scope.startDiscovery = function () {
          const url = scope.context._links['px:discoverEnvironment'].href;
          const postObject = {
            snmpConfiguration: scope.selectedSnmpConfig.info._links.self.href
          };

          if (scope.selectedWorkstation) {
            postObject.workstation = scope.selectedWorkstation.info._links.self.href;
          }

          $http.post(url, postObject).then(function (response) {
            toastr.success($filter('translate')('DiscoveryStarted'));
          }).catch(function(error){});
          scope.callback();
        };

        // TOOLTIP STUFF
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          const offsetLeft = angular.element('.context-content-container')[0].offsetLeft;
          const offsetTop = angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch (tooltipScope) {
              case 'snmpTooltip':
                snmpTooltip(position, context);
                break;
            }
          } else {
            clearTooltip();
          }
        };

        function snmpTooltip(position, context) {
          clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'snmpDescription',
            icon: 'icon-connection',
            snmpConfiguration: context
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: true
          };
        }

        function clearTooltip() {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

      }
    };
  }

  pxDiscoverPrinters.$inject = ['SnmpConfigurationService', 'WorkstationListPaging', 'NetworkListService', 'toastr', '$filter', '$http'];

  angular
    .module('printix-admin')
    .directive('pxDiscoverPrinters', pxDiscoverPrinters);

})();
